import maxios from './maxios'
import { toDomainHttpClient } from './toDomainHttpClient'

// meta 는 이 앱에서 트래킹용 쿼리 파라미터가 된다.
export const domainHttpClient = toDomainHttpClient(maxios, { forwardMeta: true })
